export default __webpack_public_path__ + "static/media/creditoja-logotipo.0c60bafb.jpg";